import React from 'react';
import PropTypes from 'prop-types';
import { tagsPropTypes } from 'constants/propTypes';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'components/Dropdown2';
import Message from 'components/Message';
import messages from './Notifications.messages';

export const ALL_VENUES_VALUE = '__ALL_VENUES__';

const VenueDropdown = ({ options, selectedId, onSelect, disabled, hasError }) => {
  const isAllVenues = selectedId === ALL_VENUES_VALUE;
  const selectedVenue = isAllVenues ? undefined : options.find(({ id }) => id === selectedId);

  let toggleContent;
  if (isAllVenues) {
    toggleContent = <Message message={messages.allVenues} />;
  } else if (selectedVenue) {
    toggleContent = <Message message={selectedVenue.name} />;
  } else {
    toggleContent = <Message className="text--light" message={messages.selectVenue} />;
  }

  return (
    <Dropdown disabled={disabled}>
      <DropdownToggle hasError={hasError} disabled={disabled}>
        {toggleContent}
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem isSelected={isAllVenues} onClick={() => onSelect(ALL_VENUES_VALUE)}>
          <Message message={messages.allVenues} />
        </DropdownItem>
        {options.map(venue => (
          <DropdownItem
            key={venue.id}
            isSelected={!isAllVenues && selectedId === venue.id}
            onClick={() => onSelect(venue.id)}>
            <Message message={venue.name} />
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

VenueDropdown.propTypes = {
  options: tagsPropTypes,
  selectedId: PropTypes.string,
  onSelect: PropTypes.func,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
};

export default VenueDropdown;
